module.exports = __webpack_public_path__ + "img/BS.7866037d.svg";